angular.module('tgaAdmin')
  .factory('cacheInterceptor', [
    '$templateCache',
    function ($templateCache) {
      return {
        request(request) {
          if (
            request.method === 'GET'
            && angular.isUndefined($templateCache.get(request.url))
            && request.url.indexOf('.html') !== -1 && request.url.indexOf('uib') === -1
          ) {
            const cacheVersion = 1;
            if (!request.params) {
              request.params = {};
            }
            if (!request.params.v) {
              request.params.v = cacheVersion;
            }
          }
          return request;
        },
      };
    },
  ]);

angular.module('tgaAdmin').config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('cacheInterceptor');
}]);
